<template>
	<div class="container">
		<div class="content">
			<div class="main-content">
				<!-- 侧边栏 -->
				<div class="sidebar">
					<div class="user-info">
						<div class="user-avatar">
							<el-avatar fit="fill" :size="100" :src="$img(userInfo.avatar)" />
						</div>
						<div class="user-name" @click="handleEditUser">
							{{ userInfo.nickname || '用户' }} 
							<i class="el-icon-edit-outline edit-icon"></i>
						</div>
						<div class="invite-code">邀请码: {{ userInfo.invite_code || '未设置' }}</div>
					</div>

					<div class="user-stats">
						<div class="stat-item" @click="$navto('/my/insureList')">
							<div class="stat-info">
								<div class="stat-icon">
									<i class="el-icon-s-order"></i>
								</div>
								<div class="stat-text">
									<div class="stat-value">{{ userInfo.orderNum || 0 }}</div>
									<div class="stat-label">我的保单</div>
								</div>
							</div>
							<i class="el-icon-arrow-right arrow-icon"></i>
						</div>

						<div class="stat-item" @click="$navto('/my/team')">
							<div class="stat-info">
								<div class="stat-icon">
									<i class="el-icon-s-custom"></i>
								</div>
								<div class="stat-text">
									<div class="stat-value">{{ userInfo.inviteNum || 0 }}</div>
									<div class="stat-label">团队成员</div>
								</div>
							</div>
							<i class="el-icon-arrow-right arrow-icon"></i>
						</div>

						<div class="stat-item" @click="$navto('/my/team')">
							<div class="stat-info">
								<div class="stat-icon">
									<i class="el-icon-s-marketing"></i>
								</div>
								<div class="stat-text">
									<div class="stat-value">¥{{ formatAmount(userInfo.teamAmount) }}</div>
									<div class="stat-label">团队保费</div>
								</div>
							</div>
							<i class="el-icon-arrow-right arrow-icon"></i>
						</div>
					</div>
				</div>

				<!-- 主内容 -->
				<div class="user-content">
					<!-- 功能卡片列表 -->
					<div class="feature-grid">
						<div 
							v-for="feature in featureList" 
							:key="feature.title"
							class="feature-card"
							@click="handleFeatureClick(feature)"
						>
							<div class="feature-header">
								<div class="feature-icon">
									<i :class="feature.icon"></i>
								</div>
								<div class="feature-content">
									<div class="feature-title">{{ feature.title }}</div>
									<div class="feature-desc">{{ feature.description }}</div>
								</div>
							</div>
							<div class="feature-actions">
								<button 
									v-for="action in feature.actions"
									:key="action.text"
									:class="['btn', action.primary ? 'btn-primary' : 'btn-secondary']"
									@click.stop="handleActionClick(action)"
								>
									<i :class="action.icon"></i>
									{{ action.text }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 编辑用户信息弹窗 -->
		<el-dialog 
			title="编辑信息" 
			width="500px" 
			:visible.sync="userEditShow"
			:close-on-click-modal="false"
		>
			<el-form label-width="80px">
				<el-form-item label="头像">
					<page-images v-model="userForm.avatar" :limit="1" />
				</el-form-item>
				<el-form-item label="昵称">
					<el-input 
						v-model="userForm.nickname" 
						placeholder="请输入昵称" 
						maxlength="20"
						show-word-limit
					/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="userEditShow = false">取消</el-button>
				<el-button 
					type="primary" 
					@click="saveUserInfo" 
					:loading="saving"
					:disabled="!userFormNickname"
				>
					保存
				</el-button>
			</div>
		</el-dialog>

		<!-- 修改密码弹窗 -->
		<el-dialog 
			title="修改密码" 
			width="500px" 
			:visible.sync="changePasswordShow"
			:close-on-click-modal="false"
		>
			<el-form label-width="100px">
				<el-form-item label="手机号码">
					<el-input 
						v-model="passwordForm.phone" 
						placeholder="请输入手机号码" 
						maxlength="11"
						@input="validatePasswordPhone"
					/>
				</el-form-item>
				<el-form-item label="验证码">
					<div class="code-group">
						<el-input 
							v-model="passwordForm.code" 
							placeholder="请输入验证码" 
							maxlength="6"
							style="width: 200px; margin-right: 10px;"
						/>
						<el-button 
							type="primary" 
							:disabled="passwordCodeCountdown > 0"
							@click="sendPasswordVerificationCode"
							style="width: 120px;"
						>
							{{ passwordCodeCountdown > 0 ? `${passwordCodeCountdown}秒后重试` : '获取验证码' }}
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="新密码">
					<el-input 
						type="password"
						v-model="passwordForm.newPassword" 
						placeholder="请设置新密码" 
						@input="validateNewPassword"
					/>
				</el-form-item>
				<el-form-item label="确认密码">
					<el-input 
						type="password"
						v-model="passwordForm.confirmNewPassword" 
						placeholder="请再次输入新密码" 
						@input="validateConfirmNewPassword"
					/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="changePasswordShow = false">取消</el-button>
				<el-button 
					type="primary" 
					@click="handleChangePassword" 
					:loading="changingPassword"
					:disabled="!isPasswordFormValid"
				>
					确认修改
				</el-button>
			</div>
		</el-dialog>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';

	export default {
		components: {
			mainFooter
		},
		data() {
			return {
				userInfo: {},
				userForm: {
					avatar: '',
					nickname: ''
				},
				userEditShow: false,
				saving: false,
				// 修改密码相关
				changePasswordShow: false,
				changingPassword: false,
				passwordCodeCountdown: 0,
				passwordForm: {
					phone: '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				},
				featureList: [
					{
						icon: 'el-icon-s-order',
						title: '我的保单',
						description: '查看和管理您的所有保单信息，包括生效中和已过期的保单',
						actions: [
							{
								text: '查看保单',
								icon: 'el-icon-tickets',
								path: '/my/insureList',
								primary: false
							}
						]
					},
					{
						icon: 'el-icon-s-promotion',
						title: '我的理赔',
						description: '申请新的理赔服务或查看历史理赔记录和处理进度',
						actions: [
							{
								text: '申请理赔',
								icon: 'el-icon-plus',
								path: '/my/createClaim',
								primary: true
							},
							{
								text: '理赔记录',
								icon: 'el-icon-tickets',
								path: '/my/claimRecord',
								primary: false
							}
						]
					},
					{
						icon: 'el-icon-s-custom',
						title: '我的团队',
						description: '管理团队成员，查看团队业绩统计和成员出单情况',
						actions: [
							{
								text: '我的团队',
								icon: 'el-icon-s-data',
								path: '/my/team',
								primary: false
							},
							{
								text: '上级团队',
								icon: 'el-icon-s-data',
								path: '/my/superiorTeam',
								primary: false
							}
						]
					},
					{
						icon: 'el-icon-s-opportunity',
						title: '投保指南',
						description: '了解投保流程、产品说明和常见问题解答',
						actions: [
							{
								text: '查看指南',
								icon: 'el-icon-info',
								path: '/insure/insureGuide',
								primary: false
							}
						]
					},
					{
						icon: 'el-icon-s-ticket',
						title: '发票管理',
						description: '查看开票记录和管理发票信息',
						actions: [
							{
								text: '发票记录',
								icon: 'el-icon-tickets',
								path: '/my/invoiceRecord',
								primary: false
							}
						]
					},
					{
						icon: 'el-icon-lock',
						title: '修改密码',
						description: '修改您的登录密码，确保账户安全',
						actions: [
							{
								text: '修改密码',
								icon: 'el-icon-edit',
								primary: true,
								type: 'changePassword'
							}
						]
					}
				]
			}
		},
		computed: {
			userFormNickname() {
				return this.userForm.nickname && this.userForm.nickname.trim();
			},
			isPasswordFormValid() {
				return this.passwordForm.phone &&
					this.passwordForm.code &&
					this.passwordForm.newPassword &&
					this.passwordForm.confirmNewPassword &&
					this.passwordForm.newPassword === this.passwordForm.confirmNewPassword &&
					this.passwordForm.newPassword.length >= 6 &&
					/^1[3-9]\d{9}$/.test(this.passwordForm.phone);
			}
		},
		mounted() {
			this.getUserInfo();
		},
		methods: {
			// 格式化金额
			formatAmount(amount) {
				return parseFloat(amount || 0).toFixed(2);
			},
			
			// 获取用户信息
			getUserInfo() {
				const userInfo = this.$getter('UserInfo');
				const userId = userInfo && userInfo.id;
				if (!userId) return;
				
				this.$get('app-user/' + userId).then(res => {
					this.userInfo = res.data || {};
					// 初始化手机号码
					if (this.userInfo.phone) {
						this.passwordForm.phone = this.userInfo.phone;
					}
					this.$vuex('UserInfo', res.data, true);
				}).catch(err => {
					this.$message.error(err || '获取用户信息失败');
				});
			},
			
			// 处理编辑用户信息
			handleEditUser() {
				this.userForm = {
					avatar: this.userInfo.avatar || '',
					nickname: this.userInfo.nickname || ''
				};
				this.userEditShow = true;
			},
			
			// 保存用户信息
			saveUserInfo() {
				if (!this.userFormNickname) {
					this.$message.warning('请输入昵称');
					return;
				}
				
				this.saving = true;
				const userInfo = this.$getter('UserInfo');
				const userId = userInfo && userInfo.id;
				
				this.$put('app-user/' + userId, this.userForm).then(res => {
					this.userEditShow = false;
					this.userInfo = res.data || {};
					this.$vuex('UserInfo', res.data, true);
					this.$message.success('修改成功');
				}).catch(err => {
					this.$message.error(err || '修改失败');
				}).finally(() => {
					this.saving = false;
				});
			},
			
			// 处理功能卡片点击
			handleFeatureClick(feature) {
				// 默认点击卡片时执行第一个操作
				if (feature.actions && feature.actions[0]) {
					this.handleActionClick(feature.actions[0]);
				}
			},
			
			// 处理功能卡片操作
			handleActionClick(action) {
				if (action.path) {
					this.$navto(action.path);
				} else if (action.type === 'changePassword') {
					this.showChangePassword();
				}
			},

			// 显示修改密码弹窗
			showChangePassword() {
				// 使用用户信息中的手机号码
				if (this.userInfo.phone) {
					this.passwordForm.phone = this.userInfo.phone;
				}
				this.changePasswordShow = true;
			},

			// 验证手机号码
			validatePasswordPhone() {
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!this.passwordForm.phone) {
					return '请输入手机号码';
				} else if (!phoneRegex.test(this.passwordForm.phone)) {
					return '手机号码格式不正确';
				}
				return '';
			},

			// 验证新密码
			validateNewPassword() {
				if (!this.passwordForm.newPassword) {
					return '请输入新密码';
				} else if (this.passwordForm.newPassword.length < 6) {
					return '密码长度至少6位';
				}
				return '';
			},

			// 验证确认密码
			validateConfirmNewPassword() {
				if (!this.passwordForm.confirmNewPassword) {
					return '请确认新密码';
				} else if (this.passwordForm.newPassword !== this.passwordForm.confirmNewPassword) {
					return '两次输入的密码不一致';
				}
				return '';
			},

			// 发送验证码
			async sendPasswordVerificationCode() {
				const phoneError = this.validatePasswordPhone();
				if (phoneError) {
					this.$message.warning(phoneError);
					return;
				}
				
				try {
					this.$post('sendAliyunSms', {
						phone: this.passwordForm.phone,
					}).then(res => {
						this.$message.success('验证码已发送');
						// 开始倒计时
						this.passwordCodeCountdown = 60;
						const timer = setInterval(() => {
							this.passwordCodeCountdown--;
							if (this.passwordCodeCountdown <= 0) {
								clearInterval(timer);
							}
						}, 1000);
					}).catch(err => {
						this.$message.error(err)
					});
				} catch (error) {
					this.$message.error('验证码发送失败，请稍后重试');
				}
			},

			// 修改密码
			async handleChangePassword() {
				if (!this.isPasswordFormValid) {
					this.$message.warning('请完善表单信息');
					return;
				}

				this.changingPassword = true;
				try {
					// 使用与忘记密码相同的接口
					await this.$post('forgetPassword', {
						phone: this.passwordForm.phone,
						code: this.passwordForm.code,
						newPassword: this.passwordForm.newPassword,
						confirmNewPassword: this.passwordForm.confirmNewPassword
					});
					
					this.$message.success('密码修改成功');
					this.changePasswordShow = false;
					this.resetPasswordForm();
				} catch (error) {
					this.$message.error(error || '密码修改失败，请稍后重试');
				} finally {
					this.changingPassword = false;
				}
			},

			// 重置密码表单
			resetPasswordForm() {
				this.passwordForm = {
					phone: this.userInfo.phone || '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				};
				this.passwordCodeCountdown = 0;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;
		min-height: 100vh;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			.main-content {
				display: grid;
				grid-template-columns: 300px 1fr;
				gap: 30px;
				align-items: start;
			}
		}
	}

	/* 侧边栏样式 */
	.sidebar {
		background: white;
		border-radius: 20px;
		padding: 30px;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
		position: sticky;
		top: 20px;
	}

	.user-info {
		text-align: center;
		padding-bottom: 25px;
		border-bottom: 1px solid #f1f5f9;
		margin-bottom: 25px;
	}

	.user-avatar {
		margin: 0 auto 20px;
	}

	.user-name {
		font-size: 22px;
		font-weight: 600;
		margin-bottom: 8px;
		color: #1e293b;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		
		&:hover .edit-icon {
			color: #2280FD;
		}
	}

	.edit-icon {
		font-size: 16px;
		color: #94a3b8;
		transition: color 0.3s ease;
	}

	.invite-code {
		background: rgba(34, 128, 253, 0.05);
		color: #2280FD;
		padding: 8px 16px;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		display: inline-block;
	}

	.user-stats {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}

	.stat-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		background: #f8fafc;
		border-radius: 12px;
		transition: all 0.3s ease;
		cursor: pointer;
		
		&:hover {
			background: rgba(34, 128, 253, 0.05);
			transform: translateX(5px);
			
			.arrow-icon {
				transform: translateX(3px);
			}
		}
	}

	.stat-info {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.stat-icon {
		width: 40px;
		height: 40px;
		background: rgba(34, 128, 253, 0.1);
		color: #2280FD;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
	}

	.stat-text {
		text-align: left;
	}

	.stat-value {
		font-size: 18px;
		font-weight: 700;
		color: #2280FD;
	}

	.stat-label {
		font-size: 12px;
		color: #94a3b8;
		margin-top: 2px;
	}

	.arrow-icon {
		color: #cbd5e1;
		transition: transform 0.3s ease;
	}

	/* 主内容区域 */
	.user-content {
		display: flex;
		flex-direction: column;
		gap: 25px;
	}

	.feature-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 25px;
	}

	.feature-card {
		background: white;
		border-radius: 16px;
		padding: 25px;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		cursor: pointer;
		border: 1px solid transparent;
		position: relative;
		overflow: hidden;
		
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 3px;
			background: linear-gradient(90deg, #2280FD, #1a6fd0);
			transform: scaleX(0);
			transition: transform 0.3s ease;
		}
		
		&:hover {
			transform: translateY(-5px);
			box-shadow: 0 15px 40px rgba(34, 128, 253, 0.15);
			border-color: rgba(34, 128, 253, 0.1);
			
			&::before {
				transform: scaleX(1);
			}
		}
	}

	.feature-header {
		display: flex;
		align-items: flex-start;
		gap: 20px;
		margin-bottom: 20px;
	}

	.feature-icon {
		flex-shrink: 0;
		width: 60px;
		height: 60px;
		background: linear-gradient(135deg, rgba(34, 128, 253, 0.1) 0%, rgba(26, 111, 208, 0.1) 100%);
		color: #2280FD;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
	}

	.feature-content {
		flex: 1;
	}

	.feature-title {
		font-size: 18px;
		font-weight: 600;
		color: #1e293b;
		margin-bottom: 8px;
	}

	.feature-desc {
		font-size: 14px;
		color: #64748b;
		line-height: 1.5;
	}

	.feature-actions {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	.btn {
		padding: 8px 16px;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: inline-flex;
		align-items: center;
		gap: 6px;
		white-space: nowrap;
		
		&:active {
			transform: translateY(1px);
		}
	}

	.btn-primary {
		background: #2280FD;
		color: white;
		box-shadow: 0 4px 12px rgba(34, 128, 253, 0.3);
		
		&:hover {
			background: #1a6fd0;
			transform: translateY(-2px);
			box-shadow: 0 6px 20px rgba(34, 128, 253, 0.4);
		}
	}

	.btn-secondary {
		background: rgba(34, 128, 253, 0.05);
		color: #2280FD;
		border: 1px solid rgba(34, 128, 253, 0.2);
		
		&:hover {
			background: rgba(34, 128, 253, 0.1);
			transform: translateY(-2px);
		}
	}

	/* 弹窗样式 */
	.dialog-footer {
		text-align: right;
	}

	.code-group {
		display: flex;
		align-items: center;
	}

	/* 响应式设计 */
	@media (max-width: 1200px) {
		.container .content {
			width: 90%;
		}
	}

	@media (max-width: 768px) {
		.container .content {
			width: 95%;
			margin: 10px auto 20px;
		}
		
		.main-content {
			grid-template-columns: 1fr !important;
			gap: 20px !important;
		}
		
		.feature-grid {
			grid-template-columns: 1fr !important;
			gap: 20px !important;
		}
		
		.support-content {
			flex-direction: column;
			text-align: center;
			gap: 15px;
		}
	}
</style>